const features = [
  {
    icon: 'ri-stack-line',
    title: 'Product Organization',
    desc: 'Structure your product research into clear categories, making it effortless to find and compare items across your entire browsing history.',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Comparison Research',
    desc: 'Side-by-side comparison tables let you evaluate products, prices, and features in one unified view — no more tab switching.',
  },
  {
    icon: 'ri-book-open-line',
    title: 'Buying Education',
    desc: 'Learn the complete buying process with step-by-step guides that walk you through research, selection, and purchasing decisions.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'QC Understanding',
    desc: 'Master quality control tracking with dedicated spreadsheet sections for inspection notes, photo references, and issue documentation.',
  },
  {
    icon: 'ri-ship-line',
    title: 'Shipping Knowledge',
    desc: 'Track carriers, compare shipping costs, and optimize delivery strategies using data-driven spreadsheet analysis.',
  },
  {
    icon: 'ri-lock-line',
    title: 'Safety Awareness',
    desc: 'Stay informed with educational resources about safe shopping practices, helping you make confident and secure purchasing decisions.',
  },
];

export default function FeatureSection() {
  return (
    <section id="guides" className="py-16 md:py-20 bg-background-50">
      <div className="container-custom">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-800 text-xs font-semibold mb-3 uppercase tracking-wide">
            Why Choose Us
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            Why Users Choose Our Superbuy Spreadsheet Guide
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
            Thousands of savvy shoppers trust our organized approach to streamline their product research and make smarter purchasing decisions.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-accent-300 transition-all duration-200"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700 mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${feature.icon} text-xl`}></i>
              </span>
              <h3 className="font-heading font-semibold text-foreground-900 mb-2 text-sm">{feature.title}</h3>
              <p className="text-foreground-600 text-xs leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}